var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuizIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.899,
    height: 33.447,
    viewBox: "0 0 34.899 33.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "quiz_icon",
    transform: "translate(-271.9 -654.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "quiz",
    d: "M200.419,209.492h-34.9V176.048h14.515l-.235.859c-.561,2.064-1.062,3.379-1.085,3.432a4.156,4.156,0,0,0-.121,1,4.374,4.374,0,0,0,8.741,0,4.066,4.066,0,0,0-.141-1.056s-.245-.64-.581-1.712c-.147-.48-.313-1.037-.483-1.665l-.23-.857h14.515v13.883l-.9-.226c-2.085-.524-3.391-.984-3.446-1a4.483,4.483,0,0,0-1.035-.116,4.188,4.188,0,1,0,0,8.368,4.585,4.585,0,0,0,1.1-.135c-.009,0,.659-.232,1.783-.557.46-.132.99-.279,1.6-.433l.9-.229v13.894Zm-33.464-1.376h32.029V197.4q-.345.095-.647.182c-1.1.32-1.763.549-1.769.551a6.062,6.062,0,0,1-1.53.2,5.564,5.564,0,1,1,0-11.119,6.081,6.081,0,0,1,1.467.179c.066.022.989.345,2.479.747V177.42H187.761c.08.27.155.524.227.755.331,1.053.573,1.684.575,1.689a5.278,5.278,0,0,1,.207,1.467,5.811,5.811,0,0,1-11.611,0,5.379,5.379,0,0,1,.187-1.406c.023-.063.379-1.006.819-2.508H166.955Z",
    transform: "translate(106.38 478.124)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-question-mark",
    "data-name": "Icon open-question-mark",
    d: "M4.963,0A5.192,5.192,0,0,0,1.185,1.326,4.384,4.384,0,0,0,0,3.9l2.009.261a2.435,2.435,0,0,1,.623-1.386,2.984,2.984,0,0,1,2.331-.764,3.545,3.545,0,0,1,2.451.683,1.68,1.68,0,0,1,.563,1.326c0,1.668-.683,2.13-1.688,3.014a5.727,5.727,0,0,0-2.331,4.521v.5H5.967v-.5c0-1.668.623-2.13,1.628-3.014A5.762,5.762,0,0,0,9.986,4.019,3.86,3.86,0,0,0,8.8,1.185,5.553,5.553,0,0,0,4.963,0Zm-1,14.065v2.009H5.967V14.065Z",
    transform: "translate(277.696 667.219)",
    fill: "#404040"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizIcon);
export default __webpack_public_path__ + "static/media/quiz_icon.fb90c473151fa407c5fbe0938650012d.svg";
export { ForwardRef as ReactComponent };